export const AccessType = {
  NONE: -1,
  READ: 0,
  WRITE: 1,
  ADMIN: 2,
  SITE_ADMIN: 100,
};

export const SortDir = {
  ASC: 1,
  DESC: -1,
};
